import { MouseEvent, useRef, useState } from 'react'
import { ArrowButton } from './ArrowButton'
import { useConfigurationStore } from '@stores/index'
import { PaginationSection } from './PaginationSection'
import { PlayButton } from './PlayButton'
import { CheckBoxSection } from './CheckBoxSection'
import useOpacityToggle from '@hooks/useOpacityToggle'
import { useIntroScreenStore } from '@stores/introScreenStore'
import { ChangeOpacityComponents, GameUIMessageType, IntroScreenType } from 'game-ui-types'
import { IntroScreenPageChangedMessage, IntroScreenStartButtonClickedMessage } from 'game-ui-types'
import { buildGradientStyle } from '@utils/buildGradientStyle'

const IntroScreen = () => {
    const introConfig = useConfigurationStore((s) => s.introScreenConfig)
    const viewport = useConfigurationStore((s) => s.viewport)
    const viewportConfigs = useIntroScreenStore((s) => s.viewportConfigs)

    const [currentPage, setCurrentPage] = useState(introConfig?.defaultPage || 0)

    const introScreenSectionRef = useRef<HTMLDivElement | null>(null)

    const paginationDotActiveLayerStyle = buildGradientStyle(
        introConfig?.layout?.paginationDotActiveLayerColors,
        'radial'
    )
    const arrowButtonInnerLayerStyle = buildGradientStyle(introConfig?.layout?.arrowButtonInnerLayerColors, '180deg')
    const playNowButtonBackgroundStyle = buildGradientStyle(introConfig?.layout?.playNowButtonBackgroundColors, '90deg')
    const playNowButtonStyle = buildGradientStyle(introConfig?.layout?.playNowButtonColors, '180deg')
    const layoutConfig = viewportConfigs[introConfig?.layout?.type || IntroScreenType.INTRO_SCREEN_CONFIG_A][viewport]

    useOpacityToggle(ChangeOpacityComponents.INTRO_SCREEN_SECTION, introScreenSectionRef)

    const handleOnArrowClick = (_: MouseEvent, number: number) => {
        setCurrentPage((prev) => {
            const introScreenPageChangedMessage: IntroScreenPageChangedMessage = {
                type: GameUIMessageType.INTRO_SCREEN_PAGE_CHANGED,
                payload: {
                    page: prev + number,
                },
            }

            window.postMessage(introScreenPageChangedMessage)

            return prev + number
        })
    }

    const handleOnStartClick = () => {
        const introScreenPageChangedMessage: IntroScreenStartButtonClickedMessage = {
            type: GameUIMessageType.INTRO_SCREEN_START_BUTTON_CLICKED,
        }

        window.postMessage(introScreenPageChangedMessage)
    }

    return (
        <div ref={introScreenSectionRef}>
            <ArrowButton
                onClick={handleOnArrowClick}
                disabled={!currentPage}
                className={layoutConfig.leftArrowButton}
                innerLayerStyle={arrowButtonInnerLayerStyle}
                isDecrement
            />
            <ArrowButton
                onClick={handleOnArrowClick}
                disabled={currentPage === introConfig?.pages}
                className={layoutConfig.rightArrowButton}
                innerLayerStyle={arrowButtonInnerLayerStyle}
            />
            <PlayButton
                onClick={handleOnStartClick}
                className={layoutConfig.playButton}
                backgroundStyle={playNowButtonBackgroundStyle}
                buttonStyle={playNowButtonStyle}
            />
            <PaginationSection
                className={layoutConfig.paginationSection}
                currentPage={currentPage}
                pages={introConfig?.pages || 0}
                activeLayerStyle={paginationDotActiveLayerStyle}
            />
            <CheckBoxSection className={layoutConfig.checkBoxSection} />
        </div>
    )
}

export default IntroScreen
